<script>
import Widget from "../../Widget.vue";
import {nextTick} from "vue";

export default {
    extends: Widget,
    name: "TermsCondition",
    emits: ["event-investment-terms-condition", "event-restart-application"],
    data() {
        return {
            confirmTermsCondition: false,
            cssStyle: 'button inv-app-form-button-disabled'
        }
    },
    mounted() {
        this.render();
    },

    methods: {
        async render() {
            this.block();
            const iframe = document.getElementById('iframeID');

            // Always wait for the iframe to load before accessing its document
            await nextTick();
            iframe.addEventListener('load', () => {
                this.unblock();
            });
        },

        previous() {
            this.$emit('event-restart-application');
        },

        next() {
            if (this.confirmTermsCondition) {
                this.$emit('event-investment-terms-condition', 2);
            }
        }
    },

    watch: {
        confirmTermsCondition(state) {
            this.cssStyle = state ? 'button button-primary' : 'button inv-app-form-button-disabled';
        }
    }
}
</script>

<template>
    <div class="investment-application-form-terms-condition">
        <iframe id="iframeID" src="https://margetts.test/storage/216/investment-terms.pdf"></iframe>
    </div>

    <div class="investment-application-form-terms-condition-container">
        <label for="terms">I have read and understood the Terms and Condition</label>

        <input type="checkbox" name="terms" id="terms" class="form-control" v-model="confirmTermsCondition"/>
    </div>

    <div class="investment-application-navigation-controls form-group">
        <button type="button" class="button" @click.stop="cancel">
            Cancel
        </button>

        <button type="button" :class="cssStyle" :disabled="! confirmTermsCondition" @click.stop="next">
            <span>Next</span>
        </button>
    </div>
</template>

<style scoped>

</style>
